/**
 * 土壤土质
 */
class DZModelQuality{
    /**
     * 土地信息ID
     */
    landId = "";

    /**
     * 土壤肥力
     */
    soilFertility = "";

    /**
     * 有效土层厚度
     */
    thickness = "";

    /**
     * 土壤盐渍化状况
     */
    salinization = "";

    /**
     * 表层土壤质地
     */
    soilTexture = "";

    /**
     * 土壤酸碱度
     */
    soilPh = "";

    /**
     * 土壤有机含量
     */
    organicContent = "";

    /**
     * 地下水埋深
     */
    groundwaterDepth = "";
}
export default DZModelQuality